import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { removeLanguageFromPath } from '../utils/languageUtils';

const LanguageToggle = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'fr' : 'en';
    i18n.changeLanguage(newLang);
    localStorage.setItem('language', newLang);
    document.documentElement.lang = newLang;
    
    // Update URL with new language
    const currentPath = removeLanguageFromPath(location.pathname);
    const newPath = `/${newLang}${currentPath === '/' ? '' : currentPath}`;
    navigate(newPath);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-1 px-3 py-1 rounded-lg hover:bg-slate-100 transition text-sm font-medium"
    >
      {i18n.language === 'en' ? (
        <>
          <span>FR</span>
        </>
      ) : (
        <>
          <span>EN</span>
        </>
      )}
    </button>
  );
};

export default LanguageToggle;
